<ng-container *finLet="isJunior$ | async as isJunior">
  <fin-login-form-container
    [fullScreen]="fullScreen"
    [invertHeaderColors]="currentStep !== JoinFlowStep.JOIN_COMPLETE"
    [icon]="currentStep === JoinFlowStep.JOIN_COMPLETE ? 'checkmark-block' : undefined"
    (closeClicked)="closeDialog()"
    [stepperSteps$]="stepperSteps$"
    [stepperActiveStep$]="stepperIndex$"
    (stepperClicked)="openStep($event)"
    [title]="(stepTranslations$ | async).title"
    [description]="(stepTranslations$ | async).description"
    *ngIf="(phonePrefixes$ | async) && currentStep$ | async as currentStep"
  >
    <div class="header-content">
      <ng-container *ngIf="currentStep === JoinFlowStep.BASIC_INFO">
        <div
          class="font-body-1 flex flex-1 flex--top ms-xsmall-r ms-xsmall-b"
          *ngFor="let promote of ['earn', 'benefits', 'offers']"
        >
          <fcom-icon [name]="'checkmark'" class="ir-xsmall ps-xsmall-r" />
          <span class="fill">{{ 'login.join.promote.' + promote | finLocalization }}</span>
        </div>
      </ng-container>

      <p class="ps-medium-y" *ngIf="isJunior && currentStep === JoinFlowStep.CONTACT_DETAILS">
        {{ 'login.join.juniorInfo' | finLocalization }}
      </p>
    </div>

    <ng-container [ngSwitch]="currentStep">
      <ng-container *ngSwitchCase="JoinFlowStep.BASIC_INFO">
        <form (submit)="moveToStep(JoinFlowStep.CONTACT_DETAILS)" [formGroup]="basicInfoForm" class="white-bg">
          <fcom-text-input
            [translationPrefix]="'login.join.fields.firstName'"
            [parentForm]="basicInfoForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'firstName'"
          ></fcom-text-input>
          <fcom-text-input
            [translationPrefix]="'login.join.fields.lastName'"
            [parentForm]="basicInfoForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'lastName'"
          ></fcom-text-input>

          <span class="font-body-1 regular-type nordic-blue-400-text" [attr.id]="'select-group-label-dob'">
            {{ 'login.join.fields.dateOfBirth.label' | finLocalization }}
          </span>

          <fin-form-group
            class="block"
            [groupTranslationPrefix]="'login.join.fields.dateOfBirth'"
            [group]="basicInfoFormBirthDate"
            [names]="['dateOfBirth', 'monthOfBirth', 'yearOfBirth']"
          >
            <div class="flex">
              <fin-select-input
                [attr.data-test-form-field]="'dateOfBirth'"
                class="flex-1 flex--basis0 mr-xsmall-r"
                [controlName]="'dateOfBirth'"
                [parentForm]="basicInfoFormBirthDate"
                [options]="availableDays$ | async"
                [displayMargin]="false"
                [disableLabel]="true"
                [translationPrefix]="'login.join.fields.dateOfBirth'"
                [selectLabelTranslationKey]="'login.join.daySelect'"
              >
              </fin-select-input>

              <fin-select-input
                [attr.data-test-form-field]="'monthOfBirth'"
                class="flex-1 flex--basis0 mr-xsmall-r"
                [controlName]="'monthOfBirth'"
                [parentForm]="basicInfoFormBirthDate"
                [options]="availableMonths$ | async"
                [displayMargin]="false"
                [disableLabel]="true"
                [translationPrefix]="'login.join.fields.monthOfBirth'"
                [selectLabelTranslationKey]="'login.join.monthSelect'"
              >
              </fin-select-input>

              <fin-select-input
                [attr.data-test-form-field]="'yearOfBirth'"
                class="flex-1 flex--basis0"
                [controlName]="'yearOfBirth'"
                [parentForm]="basicInfoFormBirthDate"
                [options]="availableYears$ | async"
                [displayMargin]="false"
                [disableLabel]="true"
                [translationPrefix]="'login.join.fields.yearOfBirth'"
                [selectLabelTranslationKey]="'login.join.yearSelect'"
              >
              </fin-select-input>
            </div>
          </fin-form-group>

          <span *ngIf="isJunior && basicInfoFormBirthDate.valid" class="font-body-2 regular-type nordic-blue-400-text">
            {{ 'login.join.joinJunior' | finLocalization }}
          </span>

          <div
            role="radiogroup"
            class="ms-medium-b pr-xsmall-t"
            [attr.aria-labelledby]="'radio-group-label-gender'"
            [attr.id]="'radio-group-gender'"
          >
            <span class="font-body-1 regular-type nordic-blue-400-text" [attr.id]="'radio-group-label-gender'">
              {{ 'login.join.fields.gender.label' | finLocalization }}
            </span>

            <div class="flex">
              <fin-radio-item
                *ngFor="let key of [LoginGender.MALE, LoginGender.FEMALE]"
                [parentForm]="basicInfoForm"
                [controlName]="'gender'"
                [isSensitive]="true"
                [translationPrefix]="'login.join.fields.gender'"
                [radioKey]="key"
                [displayContainerStyles]="false"
                class="ms-xsmall-r"
              ></fin-radio-item>
            </div>
          </div>

          <ng-container
            [ngTemplateOutlet]="continueBtn"
            [ngTemplateOutletContext]="{ disabled: !basicInfoForm.valid }"
          />
        </form>

        <button
          *ngIf="fullScreen"
          type="button"
          class="underline nordic-blue-900-text fill align-center ms-small-y tr-medium font-body-1"
          (click)="openLogin()"
        >
          {{ 'login.join.logIn' | finLocalization }}
        </button>
      </ng-container>

      <ng-container *ngSwitchCase="JoinFlowStep.CONTACT_DETAILS">
        <form
          (submit)="moveToStep(isJunior ? JoinFlowStep.GUARDIAN_DETAILS : JoinFlowStep.MARKETING_CONSENT)"
          [formGroup]="contactDetailsForm"
        >
          <fin-form-group
            class="block ps-small-b"
            [group]="contactDetailsFormPhone"
            [translationPrefix]="'login.join.fields.phone'"
            [required]="false"
            [showOnlyGroupLevelErrors]="true"
            [names]="['phonePrefix', 'phoneNumber']"
          >
            <span
              class="font-body-1 regular-type light-type nordic-blue-400-text"
              [attr.id]="'select-group-label-phone-number'"
            >
              {{ 'login.join.fields.phone.label' | finLocalization }}
            </span>

            <div class="flex">
              <fin-select-input
                class="ms-xxsmall-r flex--basis2"
                [parentForm]="contactDetailsFormPhone"
                [controlName]="'phonePrefix'"
                [options]="phonePrefixes$ | async"
                [displayMargin]="false"
                [disableSelectOption]="true"
                [disableLabel]="true"
              ></fin-select-input>
              <fcom-text-input
                [class.fill]="fullScreen"
                [parentForm]="contactDetailsFormPhone"
                [displayMargin]="false"
                [hideLabel]="true"
                [controlName]="'phoneNumber'"
              ></fcom-text-input>
            </div>
          </fin-form-group>
          <fcom-text-input
            class="block ps-small-b"
            [translationPrefix]="'login.join.fields.email'"
            [parentForm]="contactDetailsForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'email'"
          ></fcom-text-input>

          <fin-form-group
            class="block"
            [groupTranslationPrefix]="'login.join.fields.confirmPassword'"
            [group]="contactDetailsFormPassword"
            [names]="['pwd', 'confirmPwd']"
          >
            <fcom-text-input
              *finLet="passwordVisibility$ | async as visible"
              class="block ps-small-b"
              [translationPrefix]="'login.join.fields.password'"
              [parentForm]="contactDetailsFormPassword"
              [displayMargin]="false"
              [required]="false"
              [controlName]="'pwd'"
              [inputType]="visible ? InputType.TEXT : InputType.PASSWORD"
              [icon]="visible ? 'visible' : 'not-visible'"
              (iconClicked)="passwordVisibility$.next(!visible)"
            ></fcom-text-input>
            <fcom-text-input
              *finLet="confirmPasswordVisibility$ | async as visible"
              [translationPrefix]="'login.join.fields.confirmPassword'"
              [parentForm]="contactDetailsFormPassword"
              [displayMargin]="false"
              [required]="false"
              [controlName]="'confirmPwd'"
              [inputType]="visible ? InputType.TEXT : InputType.PASSWORD"
              [icon]="visible ? 'visible' : 'not-visible'"
              (iconClicked)="confirmPasswordVisibility$.next(!visible)"
            ></fcom-text-input>
          </fin-form-group>

          <ng-container
            *ngIf="!isJunior"
            [ngTemplateOutlet]="termsAndPolicy"
            [ngTemplateOutletContext]="{
              formGroup: contactDetailsForm,
              control: 'accept',
              contentUrl: 'fragments.acceptProgramRules.url'
            }"
          />

          <ng-container
            [ngTemplateOutlet]="continueBtn"
            [ngTemplateOutletContext]="{
              disabled: !(contactDetailsForm.valid && (isJunior || contactDetailsForm.get('accept').value))
            }"
          />
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="JoinFlowStep.GUARDIAN_DETAILS">
        <form (submit)="complete(true)" [formGroup]="guardianInfoForm">
          <fcom-text-input
            [translationPrefix]="'login.join.fields.guardianName'"
            [parentForm]="guardianInfoForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'guardianName'"
          ></fcom-text-input>

          <fin-form-group
            class="block ps-small-y"
            [group]="guardianInfoFormPhone"
            [translationPrefix]="'login.join.fields.guardianPhone'"
            [required]="false"
            [showOnlyGroupLevelErrors]="true"
            [names]="['phonePrefix', 'phoneNumber']"
          >
            <span
              class="font-body-1 regular-type light-type nordic-blue-400-text"
              [attr.id]="'select-group-label-guardian-phone-number'"
            >
              {{ 'login.join.fields.guardianPhone.label' | finLocalization }}
            </span>

            <div class="flex">
              <fin-select-input
                class="ms-xxsmall-r flex--basis2"
                [parentForm]="guardianInfoFormPhone"
                [controlName]="'phonePrefix'"
                [options]="phonePrefixes$ | async"
                [displayMargin]="false"
                [disableSelectOption]="true"
                [disableLabel]="true"
              ></fin-select-input>
              <fcom-text-input
                [class.fill]="fullScreen"
                [parentForm]="guardianInfoFormPhone"
                [displayMargin]="false"
                [hideLabel]="true"
                [controlName]="'phoneNumber'"
              ></fcom-text-input>
            </div>
          </fin-form-group>

          <fcom-text-input
            [translationPrefix]="'login.join.fields.guardianEmail'"
            [parentForm]="guardianInfoForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'guardianEmail'"
          ></fcom-text-input>

          <fcom-text-input
            class="ps-small-t block"
            [translationPrefix]="'login.join.fields.guardianMemberNumber'"
            [parentForm]="guardianInfoForm"
            [displayMargin]="false"
            [required]="false"
            [controlName]="'guardianMemberNumber'"
          ></fcom-text-input>

          <ng-container
            [ngTemplateOutlet]="termsAndPolicy"
            [ngTemplateOutletContext]="{
              formGroup: guardianInfoForm,
              control: 'consent',
              contentUrl: 'fragments.guardianProgramRules.url'
            }"
          />

          <ng-container
            [ngTemplateOutlet]="continueBtn"
            [ngTemplateOutletContext]="{
              disabled: !guardianInfoForm.get('consent').value || !guardianInfoForm.valid,
              loading: (loading$ | async),
              label: 'login.join.joinFinnairPlus'
            }"
          />
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="JoinFlowStep.MARKETING_CONSENT">
        <p class="ps-medium-y">{{ 'login.join.marketingEmailsAbout' | finLocalization }}</p>

        <form (submit)="complete()" [formGroup]="marketingConsentForm" *ngIf="consentTexts$ | async as consents">
          <fcom-checkbox
            class="block ps-medium-t ps-large-b"
            [name]="'acceptFlightOffers'"
            [formControlName]="'acceptFlightOffers'"
            [cid]="'acceptFlightOffers'"
          >
            <div [innerHTML]="consents[ConsentTextId.FLIGHT_OFFERS]"></div>
          </fcom-checkbox>

          <fcom-checkbox
            class="block ps-xxsmall-b"
            [name]="'acceptFinnairPlusOffers'"
            [formControlName]="'acceptFinnairPlusOffers'"
            [cid]="'acceptFinnairPlusOffers'"
          >
            <div [innerHTML]="consents[ConsentTextId.MEMBER_OFFERS]"></div>
          </fcom-checkbox>

          <p class="font-body-1 ms-large-t regular-type">{{ 'login.join.marketingConsentInfo' | finLocalization }}</p>
          <ng-container
            [ngTemplateOutlet]="continueBtn"
            [ngTemplateOutletContext]="{ label: 'login.join.joinFinnairPlus', loading: (loading$ | async) }"
          />
        </form>
      </ng-container>

      <ng-container *ngSwitchCase="JoinFlowStep.JOIN_COMPLETE">
        <p class="font-body-1 regular-type">
          {{ 'login.join.completedEmailSent' | finLocalization: { email: contactDetailsForm.controls['email'].value } }}
        </p>

        <ng-container
          [ngTemplateOutlet]="continueBtn"
          [ngTemplateOutletContext]="{
            label: 'login.join.logIn',
            icon: { category: 'svg-library', name: 'single-pax', position: IconPosition.LEFT },
            login: true
          }"
        />

        <fcom-button
          [size]="ButtonSize.R_MEDIUM"
          [theme]="ButtonTheme.SECONDARY"
          [mode]="ButtonMode.FILL"
          (click)="readMore()"
          [text]="'login.join.readMore' | finLocalization"
        ></fcom-button>
      </ng-container>
    </ng-container>
  </fin-login-form-container>
</ng-container>

<ng-template
  #continueBtn
  let-disabled="disabled"
  let-label="label"
  let-icon="icon"
  let-login="login"
  let-loading="loading"
>
  <fcom-button
    [type]="ButtonType.SUBMIT"
    [aria]="{ label: label ?? 'actions.continue' | finLocalization, loadingLabel: 'actions.loading' | finLocalization }"
    [disabled]="disabled"
    [loading]="loading"
    (click)="login ? openLogin() : undefined"
    [theme]="ButtonTheme.PRIMARY_BLUE"
    [size]="ButtonSize.R_MEDIUM"
    [icon]="icon ? icon : { category: 'svg-library', name: 'arrow-right', position: IconPosition.RIGHT }"
    [mode]="ButtonMode.FILL"
    [text]="label ?? 'actions.continue' | finLocalization"
    class="ms-large-t ms-small-b"
  ></fcom-button>
</ng-template>

<ng-template #termsAndPolicy let-contentUrl="contentUrl" let-formGroup="formGroup" let-control="control">
  <div [formGroup]="formGroup" class="block ps-large-y">
    <fcom-checkbox [name]="control" [formControlName]="control" [cid]="control">
      <cms-unstyled-fragment class="block font-body-1" [contentUrl$]="contentUrl | finLocalization | finToObservable">
      </cms-unstyled-fragment>
    </fcom-checkbox>
  </div>

  <cms-unstyled-fragment
    class="block font-body-1"
    [contentUrl$]="'fragments.privacyPolicy.url' | finLocalization | finToObservable"
  >
  </cms-unstyled-fragment>
</ng-template>
